import { useTranslation } from 'react-i18next'

/** Identifiant du contenu principal, cible du lien d'évitement. */
export const MAIN_ID = 'main'

/**
 * Lien d'évitement (RGAA 12.7) : premier élément tabulable de chaque cadre, il
 * mène au contenu sans retraverser la navigation. Invisible jusqu'au focus.
 */
function SkipLink() {
  const { t } = useTranslation()
  return (
    <a
      href={`#${MAIN_ID}`}
      onClick={(event) => {
        const main = document.getElementById(MAIN_ID)
        if (!main) return
        // Le focus suit le saut, sans laisser `#main` dans l'adresse.
        event.preventDefault()
        main.focus()
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-foreground focus:shadow-lg focus:outline-2 focus:outline-offset-2 focus:outline-ring"
    >
      {t('a11y.skipToContent')}
    </a>
  )
}

export default SkipLink
